<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2021-2023 (original work) Open Assessment Technologies SA ;
    import { IconBarButton } from '@oat-sa-private/ui-elements';
    import HeaderBar from '../headerBar/HeaderBar.svelte';
    import { createEventDispatcher } from 'svelte';
    import { __ } from '@oat-sa-private/ui-core';

    const dispatch = createEventDispatcher();

    export let startActions = [{ key: 'close', icon: 'arrow-left', label: 'Close' }];
    export let actions = [];

    export let checkStates = {
        checked: 'check',
        unchecked: 'empty',
        mixed: 'minus'
    };

    export let selectedCount = 0;

    export let currentState = checkStates.unchecked;

    const iconSize = '16';
</script>

<style>
    .selectbar-span {
        padding-right: 1rem;
        cursor: pointer;
        color: white;
        display: flex;
        align-items: center;
        user-select: none;
        height: calc(100% - 1.5rem);

        & :global(button) {
            width: auto !important;
            height: auto !important;
            border: 0.25rem solid white;
            border-radius: 0.5rem;
            margin: 1rem;
        }

        &:hover,
        &:focus {
            background: var(--color-bg-actionable-secondary-hover-inverted);
        }
    }

    section :global-nested(.selectbar-span) {
        @add-mixin outline-focus 0;
    }

    section :global-nested(.headerbar) {
        --headerbar-background: var(--color-bg-inverted);
        --headerbar-height: 7rem;
        --headerbar-side-padding: 1.5rem;
    }
</style>

<section class="inverted">
    <HeaderBar {startActions} endActions={actions} maxEndActions={actions.length} {iconSize} on:action>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span
            class="selectbar-span"
            role="button"
            tabindex="0"
            on:click={() => {
                const key = 'checkboxChange';
                dispatch('action', { key });
            }}>
            <span class="selectbar-span" tabindex="-1">
                <IconBarButton
                    ariaLabel={false}
                    label=""
                    size={`base-${iconSize}`}
                    icon={`checkbox-${currentState}-${iconSize}`} /></span>
            <span class="selectbar-span">
                {currentState === checkStates.checked ? __('ALL') : selectedCount}
                {__('SELECTED')}
            </span>
        </span>
    </HeaderBar>
</section>
